/**
 * Escapes `<` so a value carrying `</script>` cannot close the inline script it is embedded in.
 * `JSON.stringify` yields `undefined` for undefined, functions and symbols, so fall back to the
 * JSON stand-in rather than throwing mid-render.
 */
export function serializeForInlineScript(value: unknown): string {
  return (JSON.stringify(value) ?? 'null').replace(/</g, '\\u003c');
}
